import {Colors} from '@eitje/assets'
import {Icon} from '~/components/icon'
import './index.less'
import {useSpinnerVisibility} from '~/components/spinner/hooks'

export const Spinner = ({delay = 0, isSpinning = true, size = 'medium'}) => {
	const isVisible = useSpinnerVisibility({delay, isSpinning})
	const iconSize = size === 'large' ? 48 : 24

	if (!isVisible) return null

	return <Icon className="spinner" fill={Colors.mediumBlue} iconLibrary="eitje" name="loading" size={iconSize} />
}
